import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

function getHostname() {
  const dashboardHost = getPublicRuntimeConfig('NEXT_PUBLIC_DASHBOARD_HOST');
  const adminHost = getPublicRuntimeConfig('NEXT_PUBLIC_ADMIN_HOST');
  return dashboardHost || adminHost;
}

export default function isExternalUrl(url: string): boolean {
  if (url.startsWith('/') || url.startsWith('#')) {
    return false;
  }
  return true;
}

export function isApiRouteUrl(url: string): boolean {
  const hostname = getHostname();
  const pathname = hostname ? new URL(url, hostname).pathname : url;
  if (!pathname) {
    return false;
  }
  if (pathname.startsWith('/auth/')) {
    return true;
  }
  if (pathname.startsWith('/api/')) {
    return true;
  }
  return false;
}
